import { AppFiles } from "../shared/apps/appFiles";
import { AppFilesService } from "../shared/apps/appFilesService";

export const apps = {
    AppFilesService,
    AppFiles
}